import dayjs from 'dayjs';

import { NotificationType, showNotification } from '@Components/design-system/notification/notification';
import { TaskService } from '@Services/Task';
import { alloPhoneNumber } from '@Utils/constants';

export const callHelpline = (userId: string) => {
  const workingHours = {
    start: 8,
    end: 21,
  };

  return dayjs().hour() >= workingHours.start && dayjs().hour() <= workingHours.end
    ? (window.location.href = `tel:${alloPhoneNumber}`)
    : TaskService.CreateTask({
        code: 'dashboard_need_help',
        userId,
        description: 'Called helpline outside working hours',
        dueDate: dayjs().add(1, 'day').toISOString(),
        team: 'care_delivery',
      }).then(() => {
        showNotification(
          NotificationType.WARNING,
          'Helpline is not available outside working hours, our team will call you back within 24 hours',
        );
        return;
      });
};
